import { PortfolioListItem, PortfolioSummaryDto } from 'types/portfolio';
import { objectToQueryParams } from 'utils/linkUtil';
import { portalAPI } from './portalAPI';
import { accumulatedQueryWithFilters } from './util/endpointBuilder';

const APIPortfolioSlice = portalAPI
    .enhanceEndpoints({
        addTagTypes: ['PortfolioSummary', 'PortfolioParties'],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            // Summary KPIs for the active scope. Arg is the already-serialised scope params (scope /
            // userIds) so distinct scopes cache under distinct keys, and resolving colleague names
            // (which aren't part of the params) doesn't trigger a refetch.
            getPortfolioSummary: builder.query<PortfolioSummaryDto, { scope?: string; userIds?: string }>({
                query: (scopeParams) => `/v1/portfolio/summary${objectToQueryParams(scopeParams)}`,
                providesTags: ['PortfolioSummary'],
            }),
            getPortfolioPartiesWithFilters: accumulatedQueryWithFilters<PortfolioListItem>(
                builder,
                '/v1/portfolio/parties',
                { providesTags: ['PortfolioParties'] }
            ),
        }),
    });

export const { useGetPortfolioSummaryQuery, useLazyGetPortfolioPartiesWithFiltersQuery } = APIPortfolioSlice;
